import { ConfigProvider } from "antd";

import { MainMenu } from "../../../index";
import { SideBarHTML } from "./components/SideBarHtml";

export const SideBar = () => {
    return (
        <SideBarHTML>
            <ConfigProvider
                theme={{
                    components: {
                        Menu: {
                            iconMarginInlineEnd: 30,
                            horizontalItemHoverBg: "white",
                            horizontalItemHoverColor: "#00b96b",
                            itemSelectedBg: "white",
                            itemSelectedColor: "#00b96b",
                            itemHoverColor: "#00b96b",
                        },
                    },
                }}
            >
                <MainMenu />
            </ConfigProvider>
        </SideBarHTML>
    );
};
